import {
  Box,
  Checkbox,
  FormControlLabel,
  FormGroup,
  LinearProgress,
  Typography,
} from '@material-ui/core'
import moment from 'moment'
import { useEffect, useState } from 'react'
import { Button, useNotify } from 'react-admin'
import Api from '../../../Apis/api.service'
import { useStyles } from '../styles'
import Alert from '@mui/material/Alert'
import { set } from 'react-hook-form'

const ConvocationsActions = ({ id, informations, refresh }) => {
  return (
    <Box>
      <ButtonProcessConvocation
        informations={informations}
        id={id}
        refresh={refresh}
      />
    </Box>
  )
}

const ConfirmButton = ({
  className,
  label,
  confirmLabel,
  cancelLabel,
  onClick,
  disabled = false,
}) => {
  const [confirm, setConfirm] = useState(false)
  if (!confirm) {
    return (
      <Button
        className={className}
        onClick={(e) => setConfirm(true)}
        label={label}
        disabled={disabled}
      />
    )
  } else {
    return (
      <>
        <Button className={className} onClick={onClick} label={confirmLabel} />
        <Button
          className={className}
          onClick={(e) => setConfirm(false)}
          label={cancelLabel}
          style={{ marginLeft: '16px' }}
        />
      </>
    )
  }
}

const LinearProgressWithLabel = (props) => {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <Box sx={{ width: '100%', mr: 1 }}>
        <LinearProgress variant="determinate" {...props} />
      </Box>
      <Box sx={{ minWidth: 35 }}>
        <Typography variant="body2" color="text.secondary">{`${Math.round(
          props.value
        )}%`}</Typography>
      </Box>
    </Box>
  )
}

const ButtonProcessConvocation = ({ id, informations, refresh }) => {
  const classes = useStyles()
  const notify = useNotify()
  const [autoTrigger, setAutoTrigger] = useState(false)
  const [fiscalStatusAndAccountant, setFiscalStatusAndAccountant] = useState({
    isClosed: false,
    accountant: null,
  })
  const [confirm, setConfirm] = useState(false)
  const [loading, setLoading] = useState(false)
  const [waiting, setWaiting] = useState(false)
  const [progress, setProgress] = useState(
    informations?.progress ? informations?.progress : 0
  )
  let timer
  const loadProgress = () => {
    timer =
      !timer &&
      setInterval(() => {
        refresh()
      }, 3000)

    if (progress == 100) {
      clearInterval(timer)
    }
  }

  useEffect(async () => {
    if (informations) {
      await checkAndEnableIfAllClosed()
      setAutoTrigger(informations.convocation_auto_trigger)
      setProgress(() => {
        return informations.progress ? informations.progress : 0
      })
      setWaiting(informations.waiting)
    }
  }, [informations])

  useEffect(() => {
    if (!informations?.error) {
      if (
        confirm ||
        (informations?.progress > 0 && informations?.progress != 100) ||
        informations?.waiting
      ) {
        loadProgress()
      }
    }
    return () => clearInterval(timer)
  }, [confirm, informations])

  const convoke = async () => {
    const res = await Api.ags.convoke(id)
    if (res.status == 204) {
      // TODO fetchProgress until 100% and refresh convocations list
      notify("Convocations en cours d'envoi")
    }
    refresh()
  }

  const checkAndEnableIfAllClosed = async () => {
    const res = await Api.ags.getFiscalClosureStatusAndAccountant(
      informations.condo_id,
      informations.id
    )
    if (res.status === 200) {
      setFiscalStatusAndAccountant(res.data)
    }
  }

  const handleAutoTrigger = async (event) => {
    setLoading(true)
    const res = await Api.ags.updateAutoTrigger(id, {
      convocation_auto_trigger: event.target.checked,
    })
    setLoading(false)
    if (res.status == 200) {
      setAutoTrigger(() => {
        return !autoTrigger
      })
    }
    refresh()
  }
  const formatDate = (key) => {
    if (informations && informations[key]) {
      return moment(informations[key]).format('LL')
    } else {
      return ''
    }
  }

  if (informations?.convocation_triggered_at || informations?.waiting) {
    if (progress > 0 || waiting) {
      return (
        <Box sx={{ width: '100%', marginTop: '16px' }}>
          {!waiting && <LinearProgressWithLabel value={progress} />}
          {waiting && (
            <>
              <Box sx={{ minWidth: 35 }}>
                <Typography variant="body2" color="text.secondary">
                  Le traitement est en attente de ressources disponible,
                  veuillez patienter quelques minutes
                </Typography>
              </Box>{' '}
              <Box sx={{ width: '100%', mr: 1 }}>
                <LinearProgress />
              </Box>
            </>
          )}
        </Box>
      )
    }
    return null
  }
  if (
    !informations?.convocation_triggered_at &&
    !informations?.waiting &&
    informations?.planned.length == 0
  ) {
    let plannedDate = formatDate('plannedTriggerDate')
    if (plannedDate) {
      return (
        <>
          <FormGroup>
            {!fiscalStatusAndAccountant.isClosed && (
              <Alert
                severity="warning"
                className={classes.alertWarning}
                style={{ margin: '10px 0' }}
              >
                <p style={{ marginLeft: '10px' }}>
                  {fiscalStatusAndAccountant.accountant ? (
                    <>
                      La comptabilité n’est pas clôturée dans Copromatic.
                      Veuillez vous rapprocher du comptable
                      <strong>
                        {` (${fiscalStatusAndAccountant.accountant.fullName} - ${fiscalStatusAndAccountant.accountant.email})`}
                        .
                      </strong>
                    </>
                  ) : (
                    <>
                      La comptabilité n’est pas clôturée dans Copromatic.
                      Veuillez vous rapprocher du comptable responsable de cette
                      copropriété.
                    </>
                  )}
                </p>
              </Alert>
            )}
            <FormControlLabel
              control={
                <Checkbox
                  checked={autoTrigger}
                  onChange={(e) => {
                    handleAutoTrigger(e)
                  }}
                  disabled={loading || !fiscalStatusAndAccountant.isClosed}
                />
              }
              label={
                !autoTrigger
                  ? `Activer l'envoi automatique ${
                      plannedDate ? `(prévue le ${plannedDate})` : ''
                    }`
                  : `Date de déclenchement prévue le ${formatDate(
                      'plannedTriggerDate'
                    )}`
              }
            />
          </FormGroup>

          {!autoTrigger && (
            <ConfirmButton
              className={classes.button}
              onClick={async (e) => {
                e.preventDefault()
                await convoke()
                setConfirm(true)
                refresh()
              }}
              label="Lancer le Processus de convocation"
              disabled={!fiscalStatusAndAccountant.isClosed}
              confirmLabel="Confirmer"
              cancelLabel="Annuler"
            />
          )}
        </>
      )
    } else {
      return null
    }
  }
  return null
}

export default ConvocationsActions
